const STORAGE_KEY = 'device_id';

// A random id for this browser, generated on first use — not a fingerprint,
// nothing about the device is measured and clearing site data throws it away
export default () => {
  const getDeviceId = () => {
    if (typeof window === 'undefined') return '';

    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored) return stored;

      const generated = nanoid(24);
      window.localStorage.setItem(STORAGE_KEY, generated);

      return generated;
    } catch (error) {
      // Private mode or blocked storage — the request still has to go through
      console.error('Device id unavailable:', error);
      return '';
    }
  };

  return {
    getDeviceId,
  };
};
